var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.6 28.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,7.3c-.3-1.2-1.3-2.2-2.5-2.5-2.2-.6-11.2-.6-11.2-.6,0,0-8.9,0-11.2.6-1.2.3-2.2,1.3-2.5,2.5-.6,2.2-.6,6.9-.6,6.9,0,0,0,4.6.6,6.9.3,1.2,1.3,2.2,2.5,2.5,2.2.6,11.2.6,11.2.6,0,0,8.9,0,11.2-.6,1.2-.3,2.2-1.3,2.5-2.5.6-2.2.6-6.9.6-6.9,0,0,0-4.6-.6-6.9ZM11.4,18.5v-8.6l7.4,4.3-7.4,4.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtubeLogo.05c8f05e7b7e4ea2cc2078e5e1c6c14d.svg";
export { ForwardRef as ReactComponent };